import MockEphemeral from '@/store/MockEphemeral'
import ServiceIntegration from '@/store/ServiceIntegration'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    MockEphemeral,
    ServiceIntegration
  }
})

export default store



// WEBPACK FOOTER //
// ./src/Store/index.js